<template>
  <div class="p-15">
    <div class="p-10 s_flex_bian_c s_bf m-b-15 " @click="()=> {$router.push('/inWarehouse/byOrder')}">
      <img class="width-80 height-80 m-r-10" src="@/assets/image/adrk.png" alt="">
      <div class="width80">
        <p class="fz-16">按单入库</p>
        <p class="tw-text-gray-400 m-t-5">入库人员按入库单进行定品、定量扫码入库，系统自动核对商品数量</p>
      </div>
    </div>
    <div class="p-10 s_flex_bian_c s_bf " @click="()=> {$router.push('/inWarehouse/byFast')}">
      <img class="width-80 height-80 m-r-10" src="@/assets/image/ksck.png" alt="">
      <div class="width80">
        <p class="fz-16">快速入库</p>
        <p class="tw-text-gray-400 m-t-5">无需创建入库单，由入库人员自选商品进行扫码入库，不限制入库数量</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { inject
  } from "vue";
  export default {
    setup() {
      const $route = inject("$route");
      const $router = inject("$router");
    }
  };
</script>
